import { SUBSCRIPTION_ACTIONS } from "./action";

// ----------------------------------------------------------------------

const subscriptionInitialState = {
  data: [],
  subscription: {},
  formError: {},
  loading: false,
  pagination: {
    currentPage: 0,
    totalPages: 1,
    perPage: 1,
    total: 1,
  },
};

// eslint-disable-next-line default-param-last
export function subscriptionReducer(state = subscriptionInitialState, action) {
  switch (action.type) {
    case SUBSCRIPTION_ACTIONS.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
